import React from 'react';
import styled from '@emotion/styled';
import { Gear } from 'core/models/drive';
import { Caret } from 'components/views/atoms/Caret';
import { createDropdownList } from 'components/views/atoms/DropdownList';
import { fontFamily } from 'components/views/default';

const Label = styled.div({
    fontFamily,
    fontSize: '18px',
});

const GearDropdownList = createDropdownList<Gear>();

const List = styled(GearDropdownList)({
    width: '100%',
    color: '#fff',
    backgroundColor: '#c9302c',
    borderColor: '#ac2925',
    fontSize: '14px',
    fontWeight: 'normal',
    lineHeight: '1.5',
    textAlign: 'center',
    ':hover': {
        backgroundColor: '#ac2925',
        borderColor: '#761c19',
    },
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
});

export type GearSelectorProps = {
    className?: string;
    gear: Gear;
    onSelect: (gear: Gear) => void;
};

export const GearSelector = (props: GearSelectorProps) => {
    const gears = [Gear.P, Gear.N, Gear.D, Gear.R];

    return (
        <List className={props.className} direction='UP' values={gears} onSelect={props.onSelect}>
            <Label>
                <span>{`GEAR: ${props.gear}`}</span>
                <Caret direction={'DOWN'} />
            </Label>
        </List>
    );
};
